import { render, staticRenderFns } from "./SelectDocumentType.vue?vue&type=template&id=09cb1f2c&"
import script from "./SelectDocumentType.vue?vue&type=script&lang=ts&"
export * from "./SelectDocumentType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports